export default {
  init() {
    const body = $('body');
    const bookWrap = $('.book-wrap');

    if (bookWrap.length) {
      $('#menu-booking-function-tab').on('click', function (e) {
        e.preventDefault();

        $('#menu-booking-venue-enquiry').addClass('show active');
      });
    }

    $(document).on('click', '.book-room-trigger', function (e) {
      e.preventDefault();

      body.addClass('right-side-open');
      $('#menu-booking-room-tab').trigger('click');
    });

    $(document).on('click', '.book-function-trigger', function (e) {
      e.preventDefault();

      body.addClass('right-side-open');
      $('#menu-booking-function-tab').trigger('click');
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/headerBook.js